export const getUrlQueryParam = (
  locationSearch: string,
  queryParam: string
): string | null => {
  const urlParams = new URLSearchParams(locationSearch);

  return urlParams.get(queryParam);
};
